import React from 'react';
import PropTypes from 'prop-types';
import {
    PlayPitchWrapper,
    PitchNumberWrapper,
    PitchHeaderWrapper,
    PitchDetailsWrapper,
    PitchSpeedWrapper,
    CountWrapper
} from './PlayPitches.style';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';

const PlayPitches = ({
    isLoading,
    pitchNumber,
    ballColor,
    description,
    pitchType,
    speed,
    balls,
    strikes,
    displayCount = true,
    offset = true,
    isInPlay,
    isInPlayOuts,
    isBall,
    isStrike,
    noPitch
}) => {
    const hasPitchDetails = (!!speed && !!pitchType) || noPitch;
    return (
        <PlayPitchWrapper
            $offset={ offset }
        >
            { !isLoading ? <PitchNumberWrapper
                $color={ ballColor }
                $offset={ offset }
                $isBall={ isBall }
                $isStrike={ isStrike }
                $isInPlay={ isInPlay }
                $isInPlayOuts={ isInPlayOuts }
            >
                {pitchNumber}
            </PitchNumberWrapper> : <Skeleton height='32px' width='32px' isCircle />
            }

            { !isLoading ? <PitchHeaderWrapper $singleLine={!hasPitchDetails && !noPitch} $noPitch={noPitch}>
                {description}{displayCount ? <CountWrapper>{balls} - {strikes}</CountWrapper> : null }
            </PitchHeaderWrapper> : <Skeleton height='17px' width='120px' margin='2px' /> }

            { !isLoading ? hasPitchDetails && <PitchDetailsWrapper
                $offset={ offset }
            >
                {!!speed && <PitchSpeedWrapper>
                    {speed} mph
                </PitchSpeedWrapper>}
                {pitchType}
            </PitchDetailsWrapper> : <Skeleton height='17px' width='200px' margin='2px' /> }

        </PlayPitchWrapper>
    );
};

PlayPitches.propTypes = {
    isLoading: PropTypes.bool,
    pitchNumber: PropTypes.number,
    ballColor: PropTypes.string,
    description: PropTypes.string,
    pitchType: PropTypes.string,
    speed: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    balls: PropTypes.number,
    strikes: PropTypes.number,
    displayCount: PropTypes.bool,
    offset: PropTypes.bool,
    isInPlay: PropTypes.bool,
    isInPlayOuts: PropTypes.bool,
    isBall: PropTypes.bool,
    isStrike: PropTypes.bool,
    noPitch: PropTypes.bool
};

export default PlayPitches;
